import { render, staticRenderFns } from "./company-avatar.vue?vue&type=template&id=7797e5c6&scoped=true&"
import script from "./company-avatar.vue?vue&type=script&lang=ts&"
export * from "./company-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./company-avatar.vue?vue&type=style&index=0&id=7797e5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7797e5c6",
  null
  
)

export default component.exports